import { useMemo } from "react";
import { ThousandSeparator } from "../../../utils/utils";

export const _handleGetYearOptions = (initialYear, lastYear) => {
  let yearList = [];
  for (let i = initialYear; i <= lastYear; i++) {
    yearList.push({
      key: Number(i),
      value: String(i),
    });
  }
  return yearList;
};

export const getAnnualReductionValue = (y, model) => {
  const models = {
    ghg_15: { m: -0.31, c: 2.7 },
    ghg_30: { m: -0.48, c: 2.84 },
    co2_15: { m: -0.31, c: 2.62 },
    co2_30: { m: 0.44, c: 2.72 },
    ghg_gdp_15: { m: -0.53, c: 4.11 },
    ghg_gdp_30: { m: -1.1, c: 4.93 },
    co2_mwh_15: { m: -0.33, c: 3.33 },
    co2_mwh_30: { m: -0.78, c: 3.9 },
    co2_pe_15: { m: -0.51, c: 3.0 },
    co2_pe_30: { m: 0.66, c: 3.21 },
  };

  if (!models[model]) {
    return "";
  }
  const { m, c } = models[model];
  return (y - c) / m;
};

export const calculateTargetReduction = (sbti) => {
  const {
    isSBTI,
    targetYear,
    baseYear,
    sbtiTemperature,
    regressionModel,
    targetReduction,
  } = sbti || {};
  const value = isSBTI
    ? (targetYear - baseYear) *
      getAnnualReductionValue(sbtiTemperature, regressionModel)
    : targetReduction;
  return isSBTI ? ThousandSeparator(value) : value;
};

export const getTotalTargetReduction = (SBTiSettingForm) => {
  const {
    sbtiTemperature,
    regressionModel,
    reductionScopes = {},
  } = SBTiSettingForm || {};
  const totalTargetReduction = useMemo(() => {
    const total = Object.entries(reductionScopes).reduce(
      (acc, [key, { isSelect, baseline }]) => {
        return isSelect ? acc + (Number(baseline) || 0) : acc;
      },
      0,
    );

    return (
      total * (Number(calculateTargetReduction(SBTiSettingForm)) / 100 || 1)
    );
  }, [sbtiTemperature, regressionModel, Object.entries(reductionScopes)]);

  return totalTargetReduction;
};
